import {
  requiredElement,
  emailValidElement,
  maxLengthElement,
  minLengthElement,
} from "@/services/ValidatorService";
import { i18n } from "@/i18n";

export const registerUserForm = {
  name: {
    value: "",
    props: {
      type: "text",
    },
    rules: [requiredElement, maxLengthElement(50)],
  },
  email: {
    value: "",
    props: {
      type: "email",
    },
    rules: [requiredElement, emailValidElement],
  },
  phone: {
    value: "",
    props: {
      type: "tel",
    },
    rules: [requiredElement, maxLengthElement(10)],
  },
  address: {
    value: "",
    props: {
      type: "text",
    },
    rules: [requiredElement, maxLengthElement(50)],
  },
};

export const typePermission = {
  value: "",
  rules: [requiredElement],
};
export const password = {
  password: {
    value: "",
    props: {
      type: "password",
    },
    rules: [requiredElement, minLengthElement(8)],
  },
  passwordConfirm: {
    value: "",
    props: {
      type: "password",
    },
    rules: [requiredElement, minLengthElement(8)],
  },
};
